module.exports = __webpack_public_path__ + "img/mainselected.d261d332.svg";